import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { ApiClientService } from "~app/common/services/api-client.service";
import { VKAvverkningskostnadAtgardDTO, VKAvverkningskostnaderDTO } from "../dto/avverkningskostnader/avverkningskostnader-dto";
import { AvverkningskostnadAtgard } from "../models/avverkningskostnader/avverkningskostnader-models";

const mapAvverkningskostnad = (dto: VKAvverkningskostnadAtgardDTO) => new AvverkningskostnadAtgard(dto);

@Injectable({
    providedIn: "root"
})
export class AvverkningskostnaderService {
    private readonly apiClientService = inject(ApiClientService);

    getAvverkningskostnader(kontraktId: number): Observable<AvverkningskostnadAtgard[]> {
        const avverkningskostnader$ = this.apiClientService.get<VKAvverkningskostnaderDTO>(
            `virkeskop2/kontrakt/${kontraktId}/avverkningskostnader`);
        return avverkningskostnader$.pipe(map(dto =>
            dto.atgarder.map(mapAvverkningskostnad)));
    }
}
